import { Component } from '@angular/core';
import { TabGroupComponent, TabItemComponent } from '@gallaghercp/core-components/tab-group';
import { BlockAbstractComponent, PageModule } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-tabs-group',
    templateUrl: './block-tab-group.component.html',
    standalone: true,
    imports: [TabItemComponent, TabGroupComponent, PageModule],
})
export class BlockTabGroupComponent extends BlockAbstractComponent {}
